export enum ITimeFormat {
  TIME_24HR,
  TIME_12HR
}

export const ITimeFormatLabels: Record<ITimeFormat, string> = {
  [ITimeFormat.TIME_24HR]: "24 ",
  [ITimeFormat.TIME_12HR]: "12 "
};
